import {Table} from "react-bootstrap";

export default function LicenceFeatureOverview({details}) {
    return (
        <Table striped bordered>
            <thead>
            <tr>
                <th colSpan={2}>Licence Feature Overview</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    Test Mode
                </td>
                <td>
                    {details.testMode ? "True" : "False"}
                </td>
            </tr>
            <tr>
                <td>
                    Auto-enable Mode
                </td>
                <td>
                    {details.autoEnable ? "True" : "False"}
                </td>
            </tr> 
            <tr>
                <td>
                    Assigned Feature Groups
                </td>
                <td>
                    {details.featureGroups && details.featureGroups.length > 0
                        ? details.featureGroups.map(group => group.name).join(", ")
                        : "None"}
                </td>
            </tr>
            <tr>
                <td>
                    Direct Features
                </td>
                <td>
                    {details.features && details.features.length > 0
                        ? details.features.map(f => f.name).join(", ")
                        : "None"}
                </td>
            </tr>  
            <tr>
                <td>
                    Effective Features
                </td>
                <td>
                    {details.effectiveFeatures && details.effectiveFeatures.length > 0
                        ? details.effectiveFeatures.map(f => f.name).join(", ")
                        : "None"}
                </td>
            </tr>
            </tbody>
        </Table>
    )
}
